import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import AudioMic from 'src/assets/icons/icon-microphone.svg';
import './settings-modal.scss';

interface MicActivityProps {
  deviceController: any;
}

const MicActivity: React.FC<MicActivityProps> = ({ deviceController }) => {
  const { micDevice } = useSelector(({ teleTherapy }: any) => teleTherapy);
  const [micActive, setMicActive] = useState(false);
  const [micLevel, setMicLevel] = useState(0);
  let audioContext: AudioContext | null = null;
  let analyser: AnalyserNode | null = null;
  let mediaStreamSource: MediaStreamAudioSourceNode | null = null;
  let animationFrameId: number;

  const startMicAnalysis = async () => {
    try {
      if (!deviceController) {
        console.error('Device controller is not available');

        return;
      }

      // List available audio input devices
      const devices = await deviceController.listAudioInputDevices();

      if (devices.length === 0) {
        console.error('No audio input devices available');

        return;
      }

      // Start audio input
      const audioInput = await deviceController.startAudioInput(
        micDevice?.deviceId,
      );

      // Set up Web Audio API for analysis
      audioContext = new AudioContext();
      mediaStreamSource = audioContext.createMediaStreamSource(
        audioInput as MediaStream,
      );
      analyser = audioContext.createAnalyser();

      // Configure analyser
      analyser.fftSize = 256; // Controls the resolution
      const dataArray = new Uint8Array(analyser.frequencyBinCount);

      mediaStreamSource.connect(analyser);

      // Function to analyze microphone input
      const analyze = () => {
        if (analyser) {
          analyser.getByteFrequencyData(dataArray);
          const volume =
            dataArray.reduce((sum, value) => sum + value, 0) / dataArray.length;

          // Update mic state based on volume
          setMicLevel(Math.round((volume / 256) * 100)); // Convert to percentage
          setMicActive(volume > 10); // Threshold for activity
        }

        animationFrameId = requestAnimationFrame(analyze);
      };

      analyze(); // Start analyzing
    } catch (error) {
      console.error('Error starting mic analysis:', error);
    }
  };

  useEffect(() => {
    startMicAnalysis();

    // Cleanup resources on component unmount

    return () => {
      cancelAnimationFrame(animationFrameId);

      if (audioContext) {
        audioContext.close();
      }

      if (mediaStreamSource) {
        mediaStreamSource.disconnect();
      }

      if (analyser) {
        analyser.disconnect();
      }
    };
  }, [deviceController, micDevice]);

  return (
    <div className="mic-activity-indicator">
      <img src={AudioMic} className="audio-icon" alt="audio icon" />
      <div className={`indicator ${micActive ? 'active' : 'inactive'}`} />
      <span>
        {micActive ? `Mic is active (Level: ${micLevel}%)` : 'Mic is inactive'}
      </span>

      <style>{`
                        
                        .indicator {
                          width: ${micLevel}px;
                          height: 12px;
                          background-color: gray;
                        }
                       
                      `}</style>
    </div>
  );
};

export default MicActivity;
